import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash-es';

import { messages } from './messages';
import * as OrderActions from '../../store/orders/orders.actions';
import * as DrawerActions from '../../store/orders/drawer/orders.drawer.actions';
import { selectOrdersGridisSidebarVisible } from '../../store/orders/grid/orders.grid.selectors';
import { BulkActionDataType } from '../../enums/bulk-action-data-type';

const getSalesOrdersCount = (job) => get(job, 'ids.length', 0);

export const salesOrder = {
  id: BulkActionDataType.SALES_ORDER,
  getBulkApplyMessageCount: getSalesOrdersCount,

  bulkApplyMessage: (count) => (
    <FormattedMessage
      {...messages.bulkApplyMessageOrders}
      values={{
        numberOfOrders: count,
        boldOrderNumber: <b>{count}</b>,
      }}
    />
  ),

  requestFilter: (salesOrderIds) => [{ salesOrderIds }],

  startUpdateNotificationContent: (job) => {
    const salesOrdersCount = getSalesOrdersCount(job);
    const fulfillmentPlanCount = get(job, 'jobData.fulfillmentPlanCount', 0);
    return (
      <FormattedMessage
        {...messages.ordersAndShipments}
        values={{
          numberOfOrders: salesOrdersCount,
          numberOfShipments: fulfillmentPlanCount,
        }}
      />
    );
  },

  updateSuccessNotificationContent: (job) => {
    const salesOrdersCount = getSalesOrdersCount(job);
    const fulfillmentPlanCount = get(job, 'jobData.fulfillmentPlanCount', 0);
    return (
      <FormattedMessage
        {...messages.ordersAndShipmentsSuccess}
        values={{
          numberOfOrders: salesOrdersCount,
          numberOfShipments: fulfillmentPlanCount,
        }}
      />
    );
  },

  updateSuccessActions: (state) => {
    const actions = [];
    actions.push(OrderActions.silentRequestGetOrders());
    if (selectOrdersGridisSidebarVisible(state)) {
      actions.push(DrawerActions.getDrawerOrders());
    }
    return actions;
  },
};
